import { createRouter, createWebHashHistory } from 'vue-router'
import config from '../config'
import store from '@/store/index'
import Home from '../views/Home.vue'
import { message } from 'ant-design-vue'
export const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/Login')
  },
  {
    path: '/',
    name: 'Home',
    component: Home,
    redirect: { name: 'dataItem' },
    children: [
      { // 账号信息
        path: '/account',
        name: 'account',
        meta: {
          breadcrumb: ['账号信息']
        },
        component: () => import('@/views/Account/Index')
      },
      { // 团队管理
        path: '/teamManage',
        name: 'teamManage',
        meta: {
          breadcrumb: ['团队管理']
        },
        component: () => import('@/views/TeamManage/Index')
      },
      { // 账号管理
        path: '/userManage',
        name: 'userManage',
        meta: {
          breadcrumb: ['账号管理']
        },
        component: () => import('@/views/UserManage/Index')
      },
      { // 数据
        path: '/dataItem',
        name: 'dataItem',
        meta: {
          breadcrumb: ['数据管理', '数据']
        },
        component: () => import('@/views/DataPreparation/DataItem/Index')
      },
      { // 数据集
        path: '/dataSet',
        name: 'dataSet',
        meta: {
          breadcrumb: ['数据管理', '数据集']
        },
        component: () => import('@/views/DataPreparation/DataSet/Index')
      },
      { // 数据集下的数据列表
        path: '/itemList/:id',
        name: 'itemList',
        meta: {
          breadcrumb: ['数据管理', '数据集']
        },
        component: () => import('@/views/DataPreparation/DataSet/ItemList')
      },
      { // 数据上传
        path: '/dataUpload',
        name: 'dataUpload',
        meta: {
          breadcrumb: ['数据管理', '数据上传']
        },
        component: () => import('@/views/DataPreparation/DataUpload/Index')
      },
      { // 数据下载
        path: '/dataDownload',
        name: 'dataDownload',
        meta: {
          breadcrumb: ['数据管理', '数据下载']
        },
        component: () => import('@/views/DataPreparation/DataDownload/Index')
      },
      { // 数据属性
        path: '/dataAttr',
        name: 'dataAttr',
        meta: {
          breadcrumb: ['数据管理', '数据属性']
        },
        component: () => import('@/views/DataPreparation/DataAttr/Index')
      },
      { // TAG管理
        path: '/tagManage',
        name: 'tagManage',
        meta: {
          breadcrumb: ['数据管理', '标签管理']
        },
        component: () => import('@/views/DataPreparation/TagManage/Index')
      },
      { // 发布任务
        path: '/taskRelease',
        name: 'taskRelease',
        meta: {
          //breadcrumb: ['任务管理', '发布任务']
          breadcrumb: ['任务管理', '任务列表']
        },
        component: () => import('@/views/TaskManage/TaskRelease/Index')
      },

      { // 运营端 任务列表
        path: '/operateList',
        name: 'operateList',
        meta: {
          breadcrumb: ['任务管理', '任务列表']
        },
        component: () => import('@/views/TaskManage/TaskList/OperateList')
      },


      { // 运营端 合并任务列表
        path: '/mergeList',
        name: 'mergeList',
        meta: {
          breadcrumb: ['任务管理', '任务列表']
        },
        component: () => import('@/views/TaskManage/TaskList/MergeList')
      },



      // { // 运营端 删选任务
      //   path: '/taskFilter',
      //   name: 'taskFilter',
      //   meta: {
      //     breadcrumb: ['任务管理', '任务列表']
      //   },
      //   component: () => import('@/views/TaskManage/TaskList/TaskFilter')
      // },


      // { // 任务详情
      //   path: '/docs',
      //   name: 'docs',
      //   meta: {
      //     breadcrumb: ['任务管理', '说明文档'],
      //   },
        
      //   //component: () => import('@/views/TaskManage/TaskRelease/TaskDetail')
      //   component: () => import('@/views/TaskManage/TaskList/Docs')
      // },
      


      { // 服务商管理员 任务列表
        path: '/listForManager', //listForManager
        name: 'listForManager',
        meta: {
          breadcrumb: ['任务管理', '任务列表']
        },
        component: () => import('@/views/TaskManage/TaskList/ListForManager')
      },

      { // 服务商 标注员 任务列表
        path: '/listForAnnotator',
        name: 'listForAnnotator',
        meta: {
          breadcrumb: ['任务管理', '任务列表']
        },
        component: () => import('@/views/TaskManage/TaskList/ListForAnnotator')
      },


      { // 服务商 标注员 上传列表 （线下用）
        path: '/uploadList',
        name: 'uploadList',
        meta: {
          breadcrumb: ['任务管理', '上传列表'],
        },
        
        //component: () => import('@/views/TaskManage/TaskRelease/TaskDetail')
        component: () => import('@/views/TaskManage/TaskList/UploadList')
      },


      { // 服务商 质检员 任务列表
        path: '/listForInspector',
        name: 'listForInspector',
        meta: {
          breadcrumb: ['任务管理', '任务列表']
        },
        component: () => import('@/views/TaskManage/TaskList/ListForInspector')
      },

      

      { // 任务详情
        path: '/taskDetail',
        name: 'taskDetail',
        meta: {
          breadcrumb: ['任务管理', '任务详情'],
        },
        
        //component: () => import('@/views/TaskManage/TaskRelease/TaskDetail')
        component: () => import('@/views/TaskManage/TaskList/TaskDetail')
      },


      { // 发布任务详情
        path: '/labelDetail',
        name: 'labelDetail',
        meta: {
          breadcrumb: ['任务管理', '标注数据'],
        },
        
        //component: () => import('@/views/TaskManage/TaskRelease/TaskDetail')
        component: () => import('@/views/TaskManage/TaskList/LabelDetail')
      },


      { // 筛选任务务详情
        path: '/sievingDetail',
        name: 'sievingDetail',
        meta: {
          breadcrumb: ['任务管理', '标注数据'],
        },
        
        //component: () => import('@/views/TaskManage/TaskRelease/TaskDetail')
        component: () => import('@/views/TaskManage/TaskList/SievingDetail')
      },

      { // 发布任务详情
        path: '/inspectDetail',
        name: 'inspectDetail',
        meta: {
          breadcrumb: ['任务管理', '数据质检'],
        },
        
        //component: () => import('@/views/TaskManage/TaskRelease/TaskDetail')
        component: () => import('@/views/TaskManage/TaskList/InspectDetail')
      },
      
      { // 创建发布任务
        path: '/createTask',
        name: 'createTask',
        component: () => import('@/views/TaskManage/TaskRelease/CreateTask')
      },
      // { // 接收任务
      //   path: '/taskReception',
      //   name: 'taskReception',
      //   meta: {
      //     breadcrumb: ['任务管理', '接收任务']
      //   },
      //   component: () => import('@/views/TaskManage/TaskReception/Index')
      // },
      { // 标注公司 服务端 接收任务
        path: '/taskReception',
        name: 'taskReception',
        meta: {
          breadcrumb: ['任务管理', '接收任务']
        },
        component: () => import('@/views/TaskManage/TaskReception/Index')
      },
      { // 分配任务
        path: '/taskAllocation',
        name: 'taskAllocation',
        meta: {
          breadcrumb: ['任务管理', '分配任务']
        },
        component: () => import('@/views/TaskManage/TaskAllocation/Index')
      },
      { // 分配任务详情
        path: '/groupTaskDetail',
        name: 'groupTaskDetail',
        component: () => import('@/views/TaskManage/TaskAllocation/GroupTaskDetail')
      },
      { // 子任务列表页面
        path: '/subTask',
        name: 'subTask',
        meta: {
          breadcrumb: ['任务管理', '查看子任务']
        },
        component: () => import('@/views/TaskManage/TaskAllocation/SubTask')
      },
      { // 子任务详情页面
        path: '/subTaskDetail',
        name: 'subTaskDetail',
        component: () => import('@/views/TaskManage/TaskAllocation/SubTaskDetail')
      },
      // { // 标注任务
      //   path: '/myTask',
      //   name: 'myTask',
      //   meta: {
      //     breadcrumb: ['任务管理', '标注任务']
      //   },
      //   component: () => import('@/views/TaskManage/MyTask/Index')
      // },

      { // 服务公司 任务标注
        path: '/myTask',
        name: 'myTask',
        meta: {
          breadcrumb: ['任务管理', '任务标注']
        },
        component: () => import('@/views/TaskManage/MyTask/Index')
      },

      // { // 审核任务
      //   path: '/auditTask',
      //   name: 'auditTask',
      //   meta: {
      //     breadcrumb: ['任务管理', '审核任务']
      //   },
      //   component: () => import('@/views/TaskManage/MyTask/AuditTask')
      // },
      

      { // 服务公司 任务质检
        path: '/auditTask',
        name: 'auditTask',
        meta: {
          breadcrumb: ['任务管理', '任务质检']
        },
        component: () => import('@/views/TaskManage/MyTask/AuditTask')
      },

      { // 审核任务详情
        path: '/auditDetail',
        name: 'auditDetail',
        component: () => import('@/views/TaskManage/MyTask/AuditDetail')
      }
    ]
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})
router.beforeEach((to, from, next) => {
  if (to.name === 'login' || to.name === 'account') {
    next()
    return
  }
  const role = store.state.currentRole
  if (!role.roleId) {
    next('/account')
  } else {
    const permList = config.permissionDic[role.roleId]
    if (permList && permList.indexOf(to.name) !== -1) {
      next()
    } else {
      message.error('页面无权限')
    }
  }
})
export default router
